import { execAdmin } from '@src/apis/reware/utils';
import type {
  GetPricingRuleQuery,
  GetPricingRuleQueryVariables,
} from '@src/types/__generated/rewareAdminTypes';

const gql = String.raw;

export const fetchPricingRule = async ({
  partnerId,
  ruleId,
}: GetPricingRuleQueryVariables) => {
  const query = gql`
    query getPricingRule($partnerId: Int!, $ruleId: Int!) {
      partner(id: $partnerId) {
        pricingRule(ruleId: $ruleId) {
          id
          position
          condition
          department
          category
          merchantCategory
          tag
          name
          secondaryTag
          secondaryName
          tertiaryTag
          tertiaryName
          discount
          sourceColumn
          upc
        }
      }
    }
  `;

  const data = await execAdmin<GetPricingRuleQueryVariables, GetPricingRuleQuery>(query, {
    variables: { partnerId, ruleId },
  });

  if (!data.partner) {
    throw new Error(
      `fetchPricingRule: unexpected response — partner is ${data.partner === null ? 'null' : 'undefined'} (partnerId=${partnerId})`
    );
  }
  return data.partner.pricingRule;
};
